﻿import _ from "underscore";
import angular from "angular";
import moment from "moment";

export function QuickShopServices() {

	function getApiUrl() {
		return window.QuickShopSettings.apiUrl;
	}

	function ReservationService($http, cacheService) {

		var lastReservation = null;

		function convertDateStringsToDates(reservation) {
			reservation.reservationTime = moment(reservation.reservationTime);
			reservation.validFrom = moment(reservation.validFrom);
			reservation.validUntil = moment(reservation.validUntil);
			if (reservation.cancellationTime)
				reservation.cancellationTime = moment(reservation.cancellationTime);
		}

		function getLocalPriceList() {
			return cacheService.get('priceList');
		}

		function loadPriceList() {
			return $http.get(getApiUrl() + 'pricelist')
				.then(function (result) {
					if (result.status === 200)
						cacheService.set('priceList', result.data);

					return result.data;
				});
		}

		function makeReservation(spec) {
			return $http.post(getApiUrl() + 'quickshop/reservation', spec)
				.then(function (result) {
                    var reservationResult = result.data;

                    if (reservationResult.reservation) {
                        convertDateStringsToDates(reservationResult.reservation);
                        lastReservation = reservationResult.reservation;
                    }
					return reservationResult;
				});
		}

		function cancelReservation(reservationId) {
		    var sellerId = window.QuickShopSettings.sellerId;

		    return $http['delete'](getApiUrl() + 'reservation/' + reservationId, { headers: {'X-ClientId': 'quickshop', 'X-SellerId': sellerId }});
		}

		function loadLatestReservations() {
			return $http.get(getApiUrl() + 'reservation/latest')
				.then(function (result) {
					var reservations = result.data;
					_(reservations).each(convertDateStringsToDates);
					return reservations;
				});
		}

		function searchReservations(parameters) {
			return $http.post(getApiUrl() + 'reservation/search', parameters)
				.then(function (result) {
					var reservations = result.data;
					_(reservations).each(convertDateStringsToDates);
					return reservations;
				});
		}

		function loadReservation(reservationId) {
			return $http.get(getApiUrl() + 'reservation/' + reservationId)
				.then(function (result) {
					var reservation = result.data;

					convertDateStringsToDates(reservation);

					return reservation;
				});
		}

		function getLastReservation() {
			return lastReservation;
		}

		function addTicketInfoToReservation(reservation) {
			var ticketInfo = getTicketInfo();
			var reservationTickets = _(reservation.tickets);

			reservationTickets.each(function (t) {
				var ticket = ticketInfo[t.ticketId];
				t.name = ticket.ticketName;
				t.type = ticket.ticketTypeName;
				t.price = Math.round(ticket.priceExt * ticket.vatFactor);
				t.tax = Math.round((t.price - ticket.priceExt) * 100) / 100;
			});

			reservation.totalPrice = reservationTickets.reduce(function (memo, t) {
				return memo + t.price * t.quantity;
			}, 0);
			reservation.totalTax = reservationTickets.reduce(function (memo, t) {
				return memo + t.tax * t.quantity;
			}, 0);
		}

		function getTicketInfo() {
			var priceList = getLocalPriceList();

			var tickets = {};

			var categories = _.chain(priceList.categories);
			categories.pluck('subcategories').flatten().pluck('tickets').flatten().each(function (ticket) {
				tickets[ticket.ticketId] = ticket;
			});

			return tickets;
		}

		return {
			getLocalPriceList: getLocalPriceList,
			loadPriceList: loadPriceList,
			makeReservation: makeReservation,
			cancelReservation: cancelReservation,
			loadReservation: loadReservation,
			getLastReservation: getLastReservation,
			loadLatestReservations: loadLatestReservations,
			searchReservations: searchReservations,
			addTicketInfoToReservation: addTicketInfoToReservation
		};
	}

	function ReportService($http) {
		function getSummaryReport(from, to, sellerId) {
			
			var url = getSummaryReportUrl(from, to, sellerId);

			return $http.get(url)
				.then(function (result) {

					return result.data;
				});
		}

		function getSummaryReportUrl(from, to, sellerId, format) {
			var url = getApiUrl() + 'reports/summary?';
			if (from)
				url += 'from=' + from.format('YYYY-MM-DD') + '&';
			if (to)
				url += 'to=' + to.format('YYYY-MM-DD') + '&';
			if (sellerId)
				url += 'seller=' + sellerId + '&';
			if (format === 'excel')
				url += 'format=excel&token=' + encodeURIComponent(window.QuickShopSettings.token);

			return url;
		}

		function getDetailedReport(from, to, type, sellerId) {
			var url = getDetailedReportUrl(from, to, type, sellerId);

			return $http.get(url)
				.then(function (result) {
					var report = result.data;

					report.specification.from = moment(report.specification.from);
					report.specification.to = moment(report.specification.to);

					_(report.reservations).each(function (r) {
						r.reservationTime = moment(r.reservationTime);
						if (r.recalled)
							r.recalled = moment(r.recalled);
					});

					return report;
				});
		}

		function getDetailedReportUrl(from, to, type, sellerId) {
			var url = getApiUrl() + 'reports/details?type=' + type + '&';
			if (from)
				url += 'from=' + from.format('YYYY-MM-DD') + '&';
			if (to)
				url += 'to=' + to.format('YYYY-MM-DD') + '&';
			if (sellerId)
				url += 'seller=' + sellerId + '&';

			return url;
		}

		return {
			getSummaryReport: getSummaryReport,
			getSummaryReportUrl: getSummaryReportUrl,
			getDetailedReport: getDetailedReport
		};
	}

	function CartService(settingsService) {
		var cart = {
			rows: []
		};

		function addToCart(ticket, quantity) {

			var existingRow = _(cart.rows).find(function (row) { return row.ticket.id === ticket.id; });

			if (existingRow) {
				existingRow.quantity += quantity;
				existingRow.totalPrice = existingRow.quantity * ticket.price;
			} else {
				cart.rows.push({
					ticket: ticket,
					quantity: quantity,
					totalPrice: ticket.price * quantity
				});
			}

		}

		function clearCart() {
			cart.rows = [];
		}

		function getReservationSpec(customerInfo) {
			var spec = {
			    clientId: settingsService.get('ClientName') || 'quickshop',
			    sellerId: window.QuickShopSettings.sellerId,
				tickets: _(cart.rows).map(function (row) {
					return {
						quantity: row.quantity,
						ticketId: row.ticket.id
					};
				})
			};

			if (customerInfo)
				spec.customer = customerInfo;

			return spec;
		}

		function getTicketRules() {
			return _.chain(cart.rows)
				.pluck('ticket')
				.pluck('rules')
				.flatten()
				.compact()
				.map(function (x) { return x.name; })
				.uniq()
				.value();
		}

		function getTicketsWithRule(rule) {
			return _.chain(cart.rows)
				.pluck('ticket')
				.filter(function (ticket) {
					return _(ticket.rules).findWhere({ name: rule });
				})
				.value();
		}

		return {
			cart: cart,
			addToCart: addToCart,
			clearCart: clearCart,
			getReservationSpec: getReservationSpec,
			getTicketRules: getTicketRules,
			getTicketsWithRule: getTicketsWithRule
		};
	}

	function CacheService() {
		var dictionary = {};

		return {
			get: function (key) {
				if (Modernizr.localstorage) {
					var item = localStorage.getItem(key);
					if (item)
						return JSON.parse(item);
				} else {
					if (dictionary[key]) return dictionary[key];
				}

				return null;
			},
			set: function (key, value) {
				if (Modernizr.localstorage)
					localStorage.setItem(key, typeof (value) === 'string' ? value : JSON.stringify(value));
				else {
					dictionary[key] = value;
				}
			},
			remove: function (key) {
				if (Modernizr.localstorage)
					localStorage.removeItem(key);
				else {
					dictionary[key] = null;
				}
			}
		};
	}

	function SettingsService($window) {
		return {
			get: function (key) {
				return localStorage.getItem(key) || $window.QuickShopSettings['default' + key];
			},
			set: function (key, value) {
				localStorage.setItem(key, value);
			}
		};
	}

	return {
		reservationService: ReservationService,
		reportService: ReportService,
		cartService: CartService,
		cacheService: CacheService,
		settingsService: SettingsService
	};

}
